<template>
  <div class="bg-white p-3 rounded-8px">
    <Img
      v-if="props.card.illustration"
      :assetId="props.card.illustration"
      class="rounded-4px mb-2 cursor-pointer transition-width select-none w-full"
    />

    <div class="content mt-2">
      <template
        v-for="(char, idx) in card.analysis"
        :key="idx"
      >
        <span
          v-if="char[0] === 'hanzi'"
          :data-highlight="char[1] === card.hanzi[0]?.[1]"
        >
          {{ char[1] }}
        </span>
        <span v-else>{{ char }}</span>
      </template>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { KidHanziCard } from '@/types/model'

const props = defineProps<{
  card: KidHanziCard
}>()
</script>
<style scoped>
span[data-highlight='true'] {
  color: var(--primary-color);
}
.content {
  font-family: PingFang SC;
  font-weight: 600;
  font-size: 44px;
  line-height: 130%;
  letter-spacing: 0.3px;
}
</style>
